import Stay from '../domain/Stay'
import Room from '../domain/Room'
import Hotel from '../domain/Hotel'
import Filter from '../domain/Filter'
import Group from '@/room-rate-display/domain/Group'

export default class NewMapper {
  // TODO payUponArrival take from response first level, not calculate in real timer
  static fromJson ({ jsonHotel, jsonRooms, jsonStaysByRooms, minNightsPerStay, hotelCurrency, payUponArrival, searchApplicable, matchesSearch, searchType, preselectedFilters, freeUpgradeBB }) {
    return new NewMapper({ jsonHotel, jsonRooms, hotelCurrency, jsonStaysByRooms, minNightsPerStay, payUponArrival, searchApplicable, matchesSearch, searchType, preselectedFilters, freeUpgradeBB })
  }

  constructor ({ jsonHotel, jsonRooms, hotelCurrency, jsonStaysByRooms, minNightsPerStay, payUponArrival, searchApplicable, matchesSearch, searchType, preselectedFilters, freeUpgradeBB }) {
    this.jsonHotel = jsonHotel
    this.jsonRooms = jsonRooms || []
    this.jsonStaysByRooms = jsonStaysByRooms || []
    this.minNightsPerStay = minNightsPerStay || 0
    this.hotelCurrency = hotelCurrency || 'USD'
    this.payUponArrival = payUponArrival
    this.searchApplicable = searchApplicable
    this.matchesSearch = matchesSearch
    this.searchType = searchType || 'lowest'
    this.preselectedFilters = preselectedFilters || {}
    this.freeUpgradeBB = freeUpgradeBB
  }

  toDomain () {
    const self = this
    const rooms = this.jsonRooms
      .map(json => {
        const room = self.jsonStaysByRooms[json.tmsCode]
        const groups = (room && room.groups) ? room.groups : []

        // filter stays that not should show
        const createStays = (stays) => {
          return stays
            .filter(stay => !(this.searchType === 'eCert' && (!stay.matchesSearch || stay.category === 'loyalty')))
            .map(stay => Stay.fromJSON({
              ...stay,
              checkInTime: self.jsonHotel.checkInTime,
              checkOutTime: self.jsonHotel.checkOutTime,
              hotelMarkedAsMemberOnlyInCms: self.jsonHotel.memberOnlyRate,
              eCertIsApplied: self.searchType === 'eCert' && stay.matchesSearch, // TODO change to global searchApplicable
              comesFromTravelAgency: self.searchType === 'travelAgency'
            }))
        }
        return Room.fromJSON({
          ...json,
          groups: groups.map(group => Group.fromJSON({
            ...group,
            staysPublic: group.staysPublic ? createStays(group.staysPublic) : [],
            staysMember: group.staysMember ? createStays(group.staysMember) : []
          }))
        })
      })

    // map hotel
    const hotel = Hotel.fromJSON({
      ...this.jsonHotel,
      minNightsPerStay: this.minNightsPerStay,
      currency: this.hotelCurrency,
      rooms: rooms.filter(room => room.hasAvailableStays()),
      matchesSearch: this.matchesSearch, // this.jsonR.a.t.e.s.filter(stay => stay.matchesSearch).length > 0
      searchApplicable: this.searchApplicable,
      freeUpgradeBB: this.freeUpgradeBB
    })
    const availableStays = rooms
      .reduce((accumulation, room) => [...accumulation, ...room.takeAllStays()], [])

    const filter = Filter.availableOptionsFrom(availableStays, this.preselectedFilters)
    return {
      hotel,
      filter
    }
  }
}
